<template>
  <div>
    <h1 class="py-6">{{ $t('viewStorages.title') }}</h1>
    <v-progress-circular
        indeterminate
        color="primary"
        v-if="!fetched"
    />
    <v-row class="mx-0 w-100 mb-5">
      <v-col xs="6" md="4" class="pa-0 mx-0">
        <v-card class="pa-3 ma-0" elevation="0">
          <v-text-field
              outlined
              :placeholder="$t('viewStorages.search_placeholder')"
              append-outer-icon="fa-times"
              hide-details
              @click:append-outer="search=''"
              v-model="search"
              class="mb-2"
          ></v-text-field>
        </v-card>
      </v-col>
      <v-col xs="6">
        <v-btn
            min-height="48"
            class="mb-0 white--text ml-3 green-shadow float-right mr-1"
            @click="showStorageForm(null)"
            color="success"
            :title="$t('common.add')"
        >
          {{$t('common.add')}}
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
        :headers="storagesTableHeader"
        :items="filtedredStorages"
        class="elevation-0 mb-3"
        :expanded.sync="expanded"
        show-expand
        :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="pa-0 pl-1">
            <v-btn depressed fab x-small @click="toggleExpanded(props.item)">
              <v-icon v-if="expanded.includes(props.item)">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
          </td>
          <td class="text-no-wrap">{{ props.item.name }}</td>
          <td class="text-right text-no-wrap">
            <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                color="primary"
                class="mb-0 ml-3 px-0 white--text"
                @click="showStorageForm(props.item.id)"
                :title="$t('common.edit')"
            >
              <v-icon small>$pencil</v-icon>
            </v-btn>
            <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                color="success"
                class="ml-3"
                @click="showStorageRackForm(props.item.id)"
            >
              {{ $t('viewStorages.add_new_rack') }}
            </v-btn>
            <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                @click="remove('storage', props.item.id)"
                color="red lighten-2"
                class="mb-0 ml-3 px-0 white--text"
                :title="$t('common.remove')"
            >
              <v-icon small>$trash</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="px-0">
          <v-data-table
              elevation="0"
              :headers="racksTableHeader"
              :items="item.rack"
              show-expand
              hide-default-footer
          >
            <template v-slot:item.actions="{ item }">
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  color="primary"
                  class="mb-0 ml-3 px-0 white--text"
                  @click="showStorageRackForm(item.storage_id, item.id)"
                  :title="$t('common.edit')"
              >
                <v-icon small>$pencil</v-icon>
              </v-btn>
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  color="success"
                  class="ml-3"
                  @click="showStorageRackShelfForm(item.id)"
              >
                {{ $t('viewStorages.add_new_shelf') }}
              </v-btn>
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  @click="remove('rack', item.id)"
                  color="red lighten-2"
                  class="mb-0 ml-3 px-0 white--text"
                  :title="$t('common.remove')"
              >
                <v-icon small>$trash</v-icon>
              </v-btn>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="px-0">
          <v-data-table
              class="ml-5 mb-5"
              elevation="0"
              :headers="shelfTableHeader"
              :items="item.shelf.map((el)=>{el.storage_id = item.storage_id; return el;})"
              hide-default-footer
          >
            <template v-slot:item.actions="{ item, header, value}">
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  color="primary"
                  class="mb-0 ml-3 px-0 white--text"
                  @click="showStorageRackShelfForm(item.rack_id, item.id, item.storage_id)"
                  :title="$t('common.edit')"
              >
                <v-icon small>$pencil</v-icon>
              </v-btn>
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  @click="remove('shelf', item.id)"
                  color="red lighten-2"
                  class="mb-0 ml-3 px-0 white--text"
                  :title="$t('common.remove')"
              >
                <v-icon small>$trash</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              {{ $t("common.no_data_available") }}
            </template>
            <template v-slot:no-results>
              {{ $t("common.no_data_available") }}
            </template>
          </v-data-table>
        </td>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
    </td>
</template>
</v-data-table>


  <v-dialog v-model="storageWindow.visible" scrollable max-width="600px" persistent>
<v-card>
  <v-card-title><span v-if="!storage.id">{{ $t('viewStorages.adding_new') }}</span>
    <v-spacer></v-spacer>
    <v-btn icon @click="storageWindow.visible = false;" class="">
      <v-icon small>fa-times</v-icon>
    </v-btn>
  </v-card-title>
  <v-card-text>
    <v-form ref="storageForm" v-model="storageWindow.formValid">
      <v-text-field
          :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
          :value="storage.name"
          v-model="storage.name"
          :label="$t('common.title')"
          @keyup.enter.stop="storageSave"
      ></v-text-field>
      <v-divider></v-divider>
      <v-spacer></v-spacer>
      <v-btn
          :loading="savingInProgress"
          :disabled="savingInProgress"
          class="mr-2 mt-4"
          color="success"
          @click.stop="storageSave"
          @keyup.enter.stop="storageSave"
          elevation="0"
      >
        {{ $t('common.save') }}
      </v-btn>

      <v-btn
          v-if="storage.id && isVisibleExportConfig"
          :disabled="savingInProgress"
          :loading="savingInProgress"
          class="mr-2 mt-4 white--text"
          elevation="0"
          color="primary"
          :to="{ name: 'settings-goods-export'}"
      >
        <v-icon small left>fa-cog</v-icon>
        {{ $t('viewSettings.goods_export.export_settings') }}
      </v-btn>
      <v-btn
          :disabled="savingInProgress"
          :loading="savingInProgress"
          class="mr-2 mt-4 white--text"
          elevation="0"
          color="red"
          @click="storageWindow.visible=false"
          @keyup.enter="storageWindow.visible=false"
      >
        {{ $t('common.cancel') }}
      </v-btn>
    </v-form>
  </v-card-text>
</v-card>
</v-dialog>
  <v-dialog v-model="storageRackWindow.visible" scrollable max-width="600px" persistent>
  <v-card>
    <v-card-title><span v-if="!storage_rack.id">{{ $t('viewStorages.adding_new_rack') }}</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="storageRackWindow.visible = false;" class="">
        <v-icon small>fa-times</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form ref="storageRackForm" v-model="storageRackWindow.formValid">
        <v-text-field
            :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
            :value="storage_rack.name"
            v-model="storage_rack.name"
            :label="$t('common.title')"
            @keyup.enter.stop="storageRackSave"
        ></v-text-field>
        <v-btn
            :loading="savingInProgress"
            :disabled="savingInProgress"
            class="mr-2 mt-4"
            color="primary"
            @click.stop="storageRackSave"
            @keyup.enter.stop="storageRackSave"
        >
          {{ $t('common.save') }}
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
  </v-dialog>
  <v-dialog v-model="storageRackShelfWindow.visible" scrollable max-width="600px" persistent>
  <v-card>
    <v-card-title>{{ $t('viewStorages.adding_new_rack_shelf') }}
      <v-spacer></v-spacer>
      <v-btn icon @click="storageRackShelfWindow.visible = false;" class="">
        <v-icon small>fa-times</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form ref="storageRackShelfForm" v-model="storageRackShelfWindow.formValid">
        <v-text-field
            :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
            :value="storage_rack_shelf.name"
            v-model="storage_rack_shelf.name"
            :label="$t('common.title')"
            @keyup.enter.stop="storageRackShelfSave"
        ></v-text-field>
        <v-btn
            :loading="savingInProgress"
            :disabled="savingInProgress"
            class="mr-2 mt-4"
            color="primary"
            @click.stop="storageRackShelfSave"
            @keyup.enter.stop="storageRackShelfSave"
        >
          {{ $t('common.save') }}
        </v-btn>
      </v-form>
      </v-row>
    </v-card-text>
  </v-card>
  </v-dialog>


</div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
  data: () => ({
    storageRackShelfWindow: {
      formValid: null,
      visible: false
    },
    storageRackWindow: {
      formValid: null,
      visible: false
    },
    storageWindow: {
      formValid: null,
      visible: false
    },
    search: '',
    expanded: [],
  }),
  mounted() {
    this.$store.dispatch('storages/get');
  },
  methods: {
    remove(type, id){
      this.$store.dispatch(`storages/${type}_remove`, id)
          .then((result) => {
            if (result) {
              this.$store.dispatch('storages/get');
            }
          })
    },
    showStorageForm(storage_id = null) {
      if (storage_id !== null) {
        this.storage = Object.assign({}, this.storages.filter((item) => item.id === storage_id)[0]);
      } else {
        this.storage.id = null;
        this.storage.name = null;
        this.storage.storage_id = null;
        if (this.$refs.storageForm) this.$refs.storageForm.reset();
      }
      this.storageWindow.visible = true;

    },
    showStorageRackForm(storage_id, storage_rack_id = null) {

      if (storage_rack_id !== null) {
        this.storage_rack = Object.assign({}, this.storages.filter((item) => item.id === storage_id)[0].rack.filter((rk) => rk.id === storage_rack_id)[0])
      } else {
        this.storage_rack.id = null;
        this.storage_rack.name = null;
        this.storage_rack.storage_id = storage_id;
        if (this.$refs.storageRackForm) this.$refs.storageRackForm.reset();
      }
      this.storageRackWindow.visible = true;
    },
    showStorageRackShelfForm(rack_id, storage_rack_shelf_id = null, storage_id = null) {
      if (storage_rack_shelf_id != null) {
        this.storage_rack_shelf = Object.assign({}, this.storages
            .filter((item) => item.id === storage_id)[0].rack
            .filter((rk) => rk.id === rack_id)[0].shelf
            .filter((sh) => sh.id === storage_rack_shelf_id)[0]
        )
      } else {
        this.storage_rack_shelf.id = null;
        this.storage_rack_shelf.name = null;
        this.storage_rack_shelf.storage_id = null;
        this.storage_rack_shelf.rack_id = rack_id;
        if (this.$refs.storageRackShelfForm) this.$refs.storageRackShelfForm.reset();
      }
      this.storageRackShelfWindow.visible = true;
    },
    storageSave() {
      this.$refs.storageForm.validate();
      if (this.storageWindow.formValid) {
        this.$store.dispatch('storages/storage_save', this.storage)
            .then((id) => {
              if (id > 0) {
                this.$store.dispatch('storages/get');
                this.storageWindow.visible = false;
              }
            })
      }
    },
    storageRackSave() {
      this.$refs.storageRackForm.validate();
      if (this.storageRackWindow.formValid) {
        this.$store.dispatch('storages/rack_save', this.storage_rack)
            .then((id) => {
              if (id > 0) {
                this.$store.dispatch('storages/get');
                this.storageRackWindow.visible = false;
              }
            })
      }
    },
    storageRackShelfSave() {
      this.$refs.storageRackShelfForm.validate();
      if (this.storageRackShelfWindow.formValid) {
        this.$store.dispatch('storages/shelf_save', this.storage_rack_shelf)
            .then((id) => {
              if (id > 0) {
                this.$store.dispatch('storages/get');
                this.storageRackShelfWindow.visible = false;
              }
            })
      }
    },
    toggleExpanded(item) {
      if (this.expanded.filter(i => i.id == item.id).length) {
        this.expanded = this.expanded.filter(i => i.id !== item.id);
      } else {
        this.expanded.push(item)
      }
    },
  },
  computed: {
    ...mapFields("site", ["lang"]),
    ...mapFields('cart', ['cartIsLoading', 'carts']),
    ...mapFields('customers', [
      'savingInProgress',
      'customers',
      'fetched'
    ]),
    ...mapFields('storages', [
      'storage',
      'storages',
      'storage_rack',
      'storage_rack_shelf',
      'fetched',
      'savingInProgress'
    ]),
    isVisibleExportConfig(){
      return this.lang=== 'ru'
    },
    filtedredStorages() {
      return this.storages.filter(item => (!this.search.length) ? true : (item.name.toUpperCase().indexOf(this.search.toUpperCase()) != -1))
    },
    racksTableHeader() {
      return [
        {text: this.$t('viewStorages.title_rack'), value: 'name', sortable: true, class: 'text-no-wrap'},
        {text: '', value: 'actions', sortable: false, class: 'text-no-wrap', align: 'end'}
      ];
    },
    shelfTableHeader() {
      return [
        {text: this.$t('viewStorages.title_shelf'), value: 'name', sortable: true, class: 'text-no-wrap'},
        {text: '', value: 'actions', sortable: false, class: 'text-no-wrap', align: 'end'}
      ];
    },
    storagesTableHeader() {
      return [
        {text: this.$t('common.title'), value: 'name', sortable: true, class: 'text-no-wrap'},
        {text: '', class: 'text-right'},
      ];
    },
  },
}
</script>

<style >
.v-data-table tbody tr.v-data-table__expanded__content{
  -webkit-box-shadow:none !important;
  box-shadow:none !important;
}
</style>